import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import type { TGetSimChatsQueryParams } from '@homepal/api-contract'

import { useSimChatActions } from 'redux/actions/internal/SimChats'

import { ApplicationState } from 'redux/Stores/types'

import {
  selectInternalSimChat,
  selectInternalSimChatFetching,
  selectInternalSimChats
} from 'redux/selectors/internal/SimChats'

/** The stored SIM chats matching the filter, fetched when it changes. */
export const useInternalSimChats = (params: TGetSimChatsQueryParams) => {
  const { tryGetSimChats } = useSimChatActions()

  const store = useSelector(selectInternalSimChats)

  const { customer_id: customerId, rating, limit, offset } = params

  useEffect(() => {
    tryGetSimChats({
      customer_id: customerId,
      rating,
      limit,
      offset
    })
  }, [customerId, rating, limit, offset, tryGetSimChats])

  return {
    chats: store.list,
    totalCount: store.totalCount,
    loading: store.listFetching || !store.listFetched,
    refresh: () => tryGetSimChats(params)
  }
}

/** One stored SIM chat with every turn, fetched when the id changes. */
export const useInternalSimChat = (id: string | null) => {
  const { tryGetSimChat } = useSimChatActions()

  const chat = useSelector((state: ApplicationState) =>
    selectInternalSimChat(state, id)
  )
  const loading = useSelector((state: ApplicationState) =>
    selectInternalSimChatFetching(state, id)
  )

  useEffect(() => {
    if (id) tryGetSimChat(id)
  }, [id, tryGetSimChat])

  return { chat, loading }
}
